// extracted by mini-css-extract-plugin
module.exports = {"navigationLink":"NavigationLinkItem_navigationLink__DIh76"};